import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import classNames from 'classnames';

import styles from './styles';

const ADGMSwitch = props => {
  const { classes, options, selected, handleChange, customClasses } = props;

  return (
    <div className={classNames(classes.container, customClasses?.container)}>
      {options.map(opt => (
        <Button
          key={opt.value}
          onClick={() => handleChange(opt.value)}
          className={classNames(classes.btn, {
            [classes.active]: selected === opt.value,
          })}
        >
          {opt?.label}
        </Button>
      ))}
    </div>
  );
};

ADGMSwitch.propTypes = {
  classes: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  selected: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  customClasses: PropTypes.object,
};

ADGMSwitch.defaultProps = {
  selected: null,
  customClasses: {},
};

export default withStyles(styles)(ADGMSwitch);
